import { render, staticRenderFns } from "./OnboardingCards.vue?vue&type=template&id=e9f78994&scoped=true&"
import script from "./OnboardingCards.vue?vue&type=script&lang=js&"
export * from "./OnboardingCards.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingCards.vue?vue&type=style&index=0&id=e9f78994&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f78994",
  null
  
)

export default component.exports